module.exports = __webpack_public_path__ + "ce65ebc992c26b2848030cd038191baa.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room5/audio1/05_MCA-Pixelworld.ogg
// module id = 785
// module chunks = 0